export default __webpack_public_path__ + "static/media/construction site.04422a15.png";